import React from 'react';
import { Form, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Button, PasswordInput, Stack } from '@/components';
import { useInputAttributes, useTranslation } from '@/hooks';
import {
  passwordValidator,
  samePasswordValidator,
  yupValidator,
} from '@/utils';

type EnterPasswordFormData = {
  password: string;
  password_repeat: string;
};

type EnterPasswordFormProps = {
  goNext: (data: Pick<EnterPasswordFormData, 'password'>) => void;
};

const EnterPasswordForm: React.FC<EnterPasswordFormProps> = ({ goNext }) => {
  const { t } = useTranslation('pages.signUp.form.passwordForm');

  const validationSchema = yupValidator.object().shape({
    password: passwordValidator({ label: t('password') }),
    password_repeat: samePasswordValidator({ label: t('password_repeat') }),
  });

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const filedInputProps = useInputAttributes<EnterPasswordFormData>(
    control,
    register,
    errors,
    {
      password: t('password'),
      password_repeat: t('password_repeat'),
    }
  );

  const onSubmit = (data: EnterPasswordFormData) =>
    goNext({ password: data.password });

  return (
    <Stack flex={1} w="100%" h="100%" align="flex-start">
      <Form
        control={control}
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          height: '100%',
          flexGrow: 1,
        }}
      >
        <Stack flexGrow={1}>
          <PasswordInput {...filedInputProps.password} hasHint />
          <PasswordInput {...filedInputProps.password_repeat} />
        </Stack>
        <Stack w="100%" flexDir="row" align="center" justify="flex-end">
          <Button
            w="full"
            type="submit"
            onClick={(data) => void handleSubmit(onSubmit)(data)}
          >
            {t('submitPassword')}
          </Button>
        </Stack>
      </Form>
    </Stack>
  );
};
export default EnterPasswordForm;
